/* eslint-disable import/prefer-default-export */
import { ThrowErrorMsg } from '../util';
import { getRequest } from '../../services.js/apiService';

const basePathStaff = `${process.env.REACT_APP_API_URL}/staff`;

export const getPostalCodesWithNoLatLng = () => async (dispatch) => {
  try {
    const data = await getRequest(`${basePathStaff}/invalidPostalCodes`);
    return data;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};
